module.exports = __webpack_public_path__ + "img/课程介绍_02.d211f3ba.jpg";